import styled from 'styled-components';

import LogoIcon from '~/src/common/assets/logo.svg';
import Button from '~/src/common/components/Button';
import { Waves } from '~/src/common/components/Logo';
import { P } from '~/src/common/components/Typography';
import { media, zIndex } from '~/src/styles-constants';

export const MAX_CONTENT_WIDTH = 1280;

const HighlightedP = styled(P)`
  > span > span {
    font-weight: 500;
  }
`;

export const SectionContainer = styled.section`
  padding: 64px 16px 0;
  background-color: ${({ theme }) => theme.palette.background};
  justify-content: center;
`;

export const StyledWaves = styled(Waves)`
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 181px;
`;

export const SectionContent = styled.div`
  max-width: ${MAX_CONTENT_WIDTH}px;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const SectionTitle = styled.h2`
  margin: 0;
  padding-top: 10px;
  text-align: center;

  color: ${({ theme }) => theme.palette.common.TEXTS};
  font-size: 30px;
  font-weight: 700;
  font-family: ${({ theme }) => theme.fonts.secondary};
  line-height: normal;
`;

export const SectionSubTitle = styled(HighlightedP)`
  margin-top: 24px;
  text-align: center;

  &,
  span {
    font-size: 16px;
    font-weight: normal;
    line-height: 24px;
  }
`;

export const HeaderContainer = styled.header`
  position: absolute;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  background-color: ${({ theme }) => theme.palette.primary};
  height: 64px;
  z-index: ${zIndex.landingHeader};
`;

export const HeaderButton = styled(Button)`
  margin: 0;

  div > span {
    color: ${({ theme }) => theme.palette.common.WHITE};
  }
`;

export const HeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  ${media.M`
    padding: 0 36px;
  `}
`;

export const Logo = styled(LogoIcon)`
  max-height: 30px;
  width: auto;
`;
